import { observer } from 'mobx-react-lite'
import { Handle, Position } from '@xyflow/react'
import classNames from 'classnames'
import { Icon, Typography } from 'shared/ui'
import { type ISmartCallNodeProps } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/SmartCallFlowBuilderUi'
import { IncomingCallStore } from '../../store/IncomingCallStore'
import styles from './styles.module.scss'

export const IncomingCallNode = observer(({ disabled }: ISmartCallNodeProps) => {
  return (
    <>
      <div className={classNames(styles.wrap, { [styles.disabled]: disabled })}>
        <Icon icon={'phone'} color={'var(--content-primary-secondary-inverted)'} />
        <Typography ariaLabel={'IncomingCall'} variant={'body-md-regular'}>
          {IncomingCallStore.title}
        </Typography>
      </div>
      <Handle
        type='source'
        position={Position.Bottom}
        style={{ background: 'transparent', border: 'none', outline: 'none' }}
      />
    </>
  )
})
